import React from 'react';
import { motion } from 'framer-motion';
import { DollarSignIcon, ClockIcon, LeafIcon, SparklesIcon } from 'lucide-react';
const benefits = [{
  icon: DollarSignIcon,
  title: '50% Less Cost',
  description: 'Traditional remodels cost $30k+. Refacing delivers the same luxury look for half the price by keeping your existing cabinet boxes.'
}, {
  icon: ClockIcon,
  title: 'Done in 48 Hours',
  description: 'Avoid weeks of construction. Our precision-cut process allows us to transform your kitchen in just 1-2 days.'
}, {
  icon: LeafIcon,
  title: 'Eco-Friendly Choice',
  description: 'Reduce landfill waste by 70%. We reuse your high-quality cabinet structures and only replace the visible surfaces.'
}, {
  icon: SparklesIcon,
  title: 'Brand New Look',
  description: "This isn't a 'refresh'. With new doors, drawer fronts, and matching veneers, it is indistinguishable from a new kitchen."
}];
export function WhyRefacing() {
  return <section className="py-24 px-6 bg-white border-b-3 border-charcoal overflow-hidden" data-id="element-238">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }} className="max-w-7xl mx-auto" data-id="element-239">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-240">
          <div data-id="element-241">
            <span className="text-espresso font-bold uppercase tracking-widest text-sm mb-4 block" data-id="element-242">
              The Smarter Alternative
            </span>
            <h2 className="text-5xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-243">
              Why Choose <br data-id="element-244" />
              <span className="italic font-serif font-normal" data-id="element-245">
                Cabinet Refacing?
              </span>
            </h2>
            <p className="text-xl text-charcoal/60 leading-relaxed" data-id="element-246">
              Most kitchen cabinets are structurally sound, but visually
              outdated. Refacing is the process of replacing all 'wear'
              components—doors, drawer fronts, and hardware—while applying a
              matching premium veneer to the existing frames.
            </p>
          </div>
          <div className="bg-alabaster border-3 border-charcoal p-8 md:p-12 relative" data-id="element-247">
            <div className="absolute -top-4 -right-4 bg-espresso text-alabaster px-6 py-2 font-bold uppercase tracking-widest text-xs" data-id="element-248">
              The NK Difference
            </div>
            <p className="text-charcoal font-medium italic text-lg leading-relaxed mb-6" data-id="element-249">
              "We realized homeowners were spending tens of thousands to tear
              out perfectly good wood boxes just to change the color and style.
              We fixed that."
            </p>
            <div className="flex items-center gap-4" data-id="element-250">
              <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-charcoal" data-id="element-251">
                <img src="https://cdn.magicpatterns.com/uploads/wFvmPc8VX28z5mpoPGyMm4/pexels-pavel-danilyuk-8638618.jpg" alt="Nathan K." className="w-full h-full object-cover" data-id="element-252" />
              </div>
              <div data-id="element-253">
                <p className="font-bold uppercase tracking-widest text-xs" data-id="element-254">
                  Nathan K.
                </p>
                <p className="text-[10px] text-charcoal/40 uppercase tracking-widest" data-id="element-255">
                  Founder, NK Refacers
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-0 border-3 border-charcoal" data-id="element-256">
          {benefits.map((benefit, idx) => <div key={idx} className={`p-6 md:p-10 flex flex-col gap-6 ${idx % 2 === 0 ? 'border-r-3' : ''} lg:border-r-3 border-charcoal ${idx < 2 ? 'border-b-3' : 'max-lg:border-b-3'} lg:border-b-0`} data-id="element-257">
              <div className="w-12 h-12 bg-espresso/10 flex items-center justify-center" data-id="element-258">
                <benefit.icon className="w-6 h-6 text-espresso" data-id="element-259" />
              </div>
              <div data-id="element-260">
                <h3 className="text-xl font-bold mb-3" data-id="element-261">{benefit.title}</h3>
                <p className="text-sm text-charcoal/60 leading-relaxed" data-id="element-262">
                  {benefit.description}
                </p>
              </div>
            </div>)}
        </div>
      </motion.div>
    </section>;
}